import angular from 'angular'
import { ExactMatchIndex } from './exact-match-index'

/**
 * A search index for searching for customers by exact customer code match.
 *
 * @module customerCodeIndex
 */
export function CustomerCodeIndex() {
  return ExactMatchIndex.create({
    name: 'customerCodeIndex',
    entityName: 'customer',
    entityStoreName: 'customers',
    databaseIndexName: 'byCustomerCode',
  })
}

export const customerCodeIndex = CustomerCodeIndex()

angular
  .module('webregister.factories')
  .factory('customerCodeIndex', () => customerCodeIndex)
